/* X Hydration theme JS. Built from the approved main.js; cart = Shopify Ajax API (/cart/add.js, /cart.js, /cart/change.js). */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia('(max-width: 900px)').matches;
  var hasGsap = typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined';
  var XH = window.XH || {};
  var money = function (n) { var f = XH.moneyFormat || '${{amount}}'; var cents = Math.round(n * 100); var amt = (cents / 100).toFixed(2); if (/amount_no_decimals/.test(f)) amt = Math.round(n).toString(); if (/amount_with_comma_separator/.test(f)) amt = amt.replace('.', ','); return f.replace(/\{\{\s*amount[^}]*\}\}/, amt).replace(/<[^>]+>/g, ''); };

  if (hasGsap) gsap.registerPlugin(ScrollTrigger);

  /* ---------- Smooth scroll ---------- */
  var lenis = null;
  var finePointer = window.matchMedia('(pointer: fine)').matches && !window.matchMedia('(hover: none)').matches;
  if (hasGsap && !reduce && !isMobile && finePointer && typeof Lenis !== 'undefined') { /* ROUND 12: native scroll on touch devices */
    lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
    gsap.ticker.lagSmoothing(0);
  }
  var velocity = 0; // px per frame-ish, from ScrollTrigger
  if (hasGsap) {
    ScrollTrigger.create({ onUpdate: function (self) { velocity = self.getVelocity(); } });
  }

  /* ---------- Progress + nav ---------- */
  var bar = $('#progressBar'), nav = $('#nav');
  var lastY = 0;
  var darks = $$('.factors,.ingx-tested,.find,.pdp-benefits,.band,.loc-request,.footer');
  function onScroll() {
    var y = window.scrollY || document.documentElement.scrollTop;
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (bar) bar.style.transform = 'scaleX(' + (h > 0 ? y / h : 0) + ')';
    if (nav) {
      nav.classList.toggle('is-scrolled', y > 40);
      nav.classList.toggle('is-hidden', y > 600 && y > lastY + 4 && !nav.classList.contains('is-open'));
      var dark = false, probe = 44;
      for (var d = 0; d < darks.length; d++) { var r = darks[d].getBoundingClientRect(); if (r.top <= probe && r.bottom >= probe) { dark = true; break; } }
      nav.classList.toggle('is-dark', dark);
      document.body.classList.toggle('on-dark', dark);
    }
    lastY = y;
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  if (lenis) lenis.on('scroll', onScroll);
  onScroll();

  /* --- CLOSER LOOK · ingredient tabs --- */
  (function () {
    var tabs = $$('.closer__tab');
    if (!tabs.length) return;
    function show(i) {
      tabs.forEach(function (t, n) {
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        var on = n === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (panel) {
          panel.hidden = !on;
          panel.classList.toggle('is-active', on);
        }
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = (i + d + tabs.length) % tabs.length;
        show(n); tabs[n].focus();
      });
    });
  })();


  /* ---- swipe rails (Pick your X) ---- */
  document.querySelectorAll('[data-rail]').forEach(function(rail){
    var track = rail.querySelector('[data-rail-track]');
    var prev  = rail.querySelector('[data-rail-prev]');
    var next  = rail.querySelector('[data-rail-next]');
    if (!track) return;
    function step(){
      var card = track.firstElementChild;
      if (!card) return track.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(track).columnGap || '18') || 18;
      return card.getBoundingClientRect().width + gap;
    }
    var cur = rail.querySelector('[data-rail-cur]'), cnt = rail.querySelector('[data-rail-count]');
    function sync(){
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev && next) { prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft >= max; }
      if (cur) {
        var n = track.children.length, st = step(), i = Math.min(n, Math.round(track.scrollLeft / st) + 1);
        cur.textContent = (i < 10 ? '0' : '') + i;
        if (cnt) cnt.style.setProperty('--p', n > 1 ? (i - 1) / (n - 1) : 1);
      }
    }
    if (prev) prev.addEventListener('click', function(){ track.scrollBy({left:-step(), behavior:'smooth'}); });
    if (next) next.addEventListener('click', function(){ track.scrollBy({left: step(), behavior:'smooth'}); });
    var picker = rail.parentElement ? rail.parentElement.querySelector('[data-rail-picker]') : null, shelfHost = picker ? (picker.closest('.fpick-wrap') || picker) : null;
    if (picker) {
      var chips = picker.querySelectorAll('[data-rail-go]');
      var lock = -1, lockT;
      function mark(i){ chips.forEach(function(c, k){ c.classList.toggle('is-on', k === i); c.setAttribute('aria-pressed', String(k === i)); }); Array.prototype.forEach.call(track.children, function(card, k){ card.classList.toggle('is-focus', k === i); }); if (chips[i]) shelfHost.style.setProperty('--shelf', chips[i].style.getPropertyValue('--tint')); }
      mark(0);
      chips.forEach(function(c){ c.addEventListener('click', function(){
        var gi = +c.getAttribute('data-rail-go'), card = track.children[gi]; if (!card) return;
        if (c.classList.contains('is-on') && card.classList.contains('is-focus')) { var go = card.querySelector('a.product__media'); if (go && go.href) { window.location.href = go.href; return; } } /* ROUND 15: second tap opens the flavor page */
        lock = gi; mark(gi); clearTimeout(lockT); lockT = setTimeout(function(){ lock = -1; }, 900);
        track.scrollTo({left: card.offsetLeft - track.firstElementChild.offsetLeft, behavior:'smooth'});
      }); });
      track.addEventListener('scroll', function(){
        var i = Math.min(chips.length - 1, Math.round(track.scrollLeft / step()));
        if (lock > -1) { clearTimeout(lockT); lockT = setTimeout(function(){ lock = -1; }, 250); return; }
        if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 2 && track.clientWidth < step() * 1.5) i = chips.length - 1;
        mark(i);
      }, {passive:true});
    }
    track.addEventListener('scroll', sync, {passive:true});
    window.addEventListener('resize', sync);
    sync();
  });


  /* ---------- Sticky home shop bar: visible once the hero has scrolled out ---------- */
  var homebar = $('#homebar'), heroEl = $('#hero');
  if (homebar && heroEl && 'IntersectionObserver' in window) {
    var shopEl = $('#shop'), footerEl = $('#footer'), heroOut = false, nearShop = false, footIn = false;
    var sync = function () { var on = heroOut && !nearShop && !footIn; homebar.classList.toggle('is-on', on); homebar.setAttribute('aria-hidden', String(!on)); };
    new IntersectionObserver(function (es) { heroOut = !es[0].isIntersecting; sync(); }, { threshold: 0.05 }).observe(heroEl);
    if (shopEl) new IntersectionObserver(function (es) { nearShop = es[0].isIntersecting; sync(); }, { threshold: 0.15 }).observe(shopEl);
    if (footerEl) new IntersectionObserver(function (es) { footIn = es[0].isIntersecting; sync(); }, { threshold: 0.05 }).observe(footerEl);
  }
  var burger = $('#navBurger');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = !nav.classList.contains('is-open');
      nav.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', String(open));
      if (lenis) open ? lenis.stop() : lenis.start();
      document.body.style.overflow = open ? 'hidden' : '';
    });
    $$('#navMenu a').forEach(function (a) {
      a.addEventListener('click', function () {
        nav.classList.remove('is-open'); burger.setAttribute('aria-expanded', 'false');
        if (lenis) lenis.start(); document.body.style.overflow = '';
      });
    });
  }

  /* ---------- Magnetic buttons ---------- */
  if (!isMobile && hasGsap) {
    $$('[data-magnet], .btn').forEach(function (b) {
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        gsap.to(b, { x: (e.clientX - r.left - r.width / 2) * 0.18, y: (e.clientY - r.top - r.height / 2) * 0.3, duration: 0.5, ease: 'power3.out' });
      });
      b.addEventListener('mouseleave', function () { gsap.to(b, { x: 0, y: 0, duration: 0.7, ease: 'elastic.out(1,0.4)' }); });
    });
  }

  /* ---------- Generic reveals / parallax ---------- */
  /* ROUND 12 · reveals: one IntersectionObserver, CSS does the motion; nothing can get stuck hidden */
  (function () {
    var items = $$('[data-reveal],[data-cascade]>*');
    $$('[data-cascade]').forEach(function (g) { Array.prototype.forEach.call(g.children, function (c, i) { c.style.setProperty('--d', Math.min(i, 8) * 70 + 'ms'); }); });
    if (reduce || !('IntersectionObserver' in window)) { document.documentElement.classList.add('reveals-off'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    items.forEach(function (el) { io.observe(el); });
    var sweep = function () { items.forEach(function (el) { if (el.classList.contains('is-in')) return; var r = el.getBoundingClientRect(); if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in'); }); };
    setTimeout(sweep, 900); setTimeout(sweep, 2500);
    window.addEventListener('load', function () { setTimeout(sweep, 300); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) sweep(); });
  })();
  if (hasGsap && !reduce && !isMobile) {
    $$('[data-parallax]').forEach(function (el) {
      var img = el.querySelector('img') || el;
      gsap.fromTo(img, { yPercent: -8 }, { yPercent: 8, ease: 'none', scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true } });
    });
    $$('[data-parallax-wide]').forEach(function (el) {
      var img = el.querySelector('img') || el;
      gsap.fromTo(img, { yPercent: -12 }, { yPercent: 12, ease: 'none', scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true } });
    });
    var anat = $('.anatomy__bottle img');
    if (anat) {
      gsap.fromTo(anat, { yPercent: 6, rotate: -3 }, { yPercent: -6, rotate: 3, ease: 'none', scrollTrigger: { trigger: '.anatomy', start: 'top bottom', end: 'bottom top', scrub: true } });
    }
  }
  if (hasGsap && !reduce) {
    $$('.anatomy__col li').forEach(function (li, i) {
      ScrollTrigger.create({ trigger: li, start: 'top 82%', once: true, onEnter: function () { setTimeout(function () { li.classList.add('is-in'); }, (i % 3) * 120); } });
    });
  } else {
    $$('.anatomy__col li').forEach(function (li) { li.classList.add('is-in'); });
  }

  /* Word clip reveals for non-hero h1s */
  if (hasGsap) {
    $$('main:not(.page-home) h1 .w > span, .pack__title .w > span').forEach(function (s) {
      var isPack = s.closest('.pack__title');
      if (isPack) return; // handled in pack beat
      gsap.to(s, { y: 0, duration: 1.1, ease: 'power4.out', delay: 0.15 });
    });
  }

  /* ---------- Velocity-linked marquees (top marquee + social footer) ---------- */
  function marquee(track, baseSpeed, dir) {
    if (!track) return;
    var set = track.children[0]; if (!set) return;
    var x = 0, w = set.offsetWidth;
    window.addEventListener('resize', function () { w = set.offsetWidth; });
    var tick = function () {
      var v = Math.min(Math.abs(velocity) / 500, 3);
      x -= (baseSpeed + v) * dir;
      if (dir > 0 && x <= -w) x += w; if (dir < 0 && x >= 0) x -= w;
      track.style.transform = 'translate3d(' + x + 'px,0,0)';
    };
    if (hasGsap) gsap.ticker.add(tick); else setInterval(tick, 16);
  }
  if (!reduce) { marquee($('#marqueeTrack'), 0.75, 1); marquee($('#socialTrack'), 0.6, 1); }

  /* ================= HOMEPAGE BEATS ================= */
  var home = $('main.page-home');
  if (home && hasGsap && !reduce) {

    /* --- BEAT 1 · HERO: still, premium wellness water (soft entrance only) --- */
    var hero = $('#hero');
    if (hero) {
      gsap.from('#heroGlow', { scale: 0.6, opacity: 0, duration: 1.6, ease: 'power3.out' });
      gsap.fromTo('#heroTilt', { opacity: 0, y: 24 }, { opacity: 1, y: 0, duration: 1.2, ease: 'power2.out' });
      gsap.from('#heroCopy > *', { opacity: 0, y: 18, stagger: 0.1, duration: 0.9, ease: 'power3.out', delay: 0.15 });
    }

    /* --- BEAT 3 · FLAVORS: static lineup (reveals via data-cascade; hover handled in CSS) --- */

    /* --- BEAT 4 · RITUAL: words light up as the section enters --- */
    var ritual = $('#ritual');
    if (ritual) {
      var rw = $$('.ritual__word');
      var rtl = gsap.timeline({ scrollTrigger: { trigger: ritual, start: 'top 70%', end: 'center 45%', scrub: 0.6 } });
      rw.forEach(function (w, i) {
        rtl.to(w, { color: '#0A0B0D', duration: 0.14, ease: 'none' }, i * 0.15)
           .to(w, { color: i % 2 ? '#CE8DA5' : '#62B3D0', duration: 0.08 }, i * 0.15 + 0.14)
           .to(w, { color: '#0A0B0D', duration: 0.1 }, i * 0.15 + 0.24);
      });
      rtl.to('#ritualRule', { scaleX: 1, duration: 0.22, ease: 'none' }, 0.5)
         .to('.ritual__copy', { opacity: 1, y: 0, duration: 0.2 }, 0.58)
         .to('.ritual__facts', { opacity: 1, y: 0, duration: 0.2 }, 0.68)
         .to('.ritual__cta', { opacity: 1, y: 0, duration: 0.2 }, 0.76);
      gsap.fromTo('.ritual__media', { opacity: 0, y: 40, scale: 0.97 }, { opacity: 1, y: 0, scale: 1, duration: 1.4, ease: 'power3.out', scrollTrigger: { trigger: ritual, start: 'top 75%' } });
    }

    /* --- BEAT 5 · BENEFITS: static lifestyle grid (reveals via data-cascade) --- */

    /* --- BEAT 6 · X FACTORS: static scene, callouts cascade in once --- */
    var factors = $('#factors');
    if (factors) {
      var callouts = $$('.callout'), facts = $('.factors__facts');
      gsap.fromTo('.factors__head > *', { opacity: 0, y: 24 }, { opacity: 1, y: 0, stagger: 0.1, duration: 0.9, scrollTrigger: { trigger: factors, start: 'top 65%' } });
      gsap.fromTo('.factors__bottle', { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 1.4, ease: 'power3.out', scrollTrigger: { trigger: '.factors__body', start: 'top 70%' } });
      ScrollTrigger.create({ trigger: '.factors__body', start: 'top 55%', once: true, onEnter: function () {
        callouts.forEach(function (c, j) { gsap.delayedCall(0.35 + j * 0.28, function () { c.classList.add('is-on'); }); });
        if (facts) gsap.delayedCall(0.35 + callouts.length * 0.28, function () { facts.classList.add('is-on'); });
      } });
    }

    /* --- REVIEWS: boxes cascade --- */
    var reviews = $('#reviews');
    if (reviews) {
      gsap.fromTo('.reviews__head > *', { opacity: 0, y: 24 }, { opacity: 1, y: 0, stagger: 0.1, duration: 0.9, scrollTrigger: { trigger: reviews, start: 'top 75%' } });
      gsap.fromTo('.reviews__grid .rcard', { opacity: 0, y: 36 }, { opacity: 1, y: 0, stagger: 0.1, duration: 0.9, ease: 'power3.out', scrollTrigger: { trigger: '#reviewsGrid', start: 'top 82%' } });
    }

    /* SHOP grid reveal */
    var shop = $('#shop');
    if (shop) {
      gsap.fromTo('.shop__head > *', { opacity: 0, y: 24 }, { opacity: 1, y: 0, stagger: 0.1, duration: 0.9, scrollTrigger: { trigger: shop, start: 'top 75%' } });
      gsap.fromTo('.shop .product', { opacity: 0, y: 40 }, { opacity: 1, y: 0, stagger: 0.08, duration: 0.9, ease: 'power3.out', scrollTrigger: { trigger: '.shop__grid', start: 'top 80%' } });
    }
  } else if (home) {
    // Reduced motion / no GSAP: reveal everything statically
    $$('.w > span, #heroSub, .callout, .factors__facts, .ritual__copy, .ritual__facts, .ritual__cta').forEach(function (el) { el.style.opacity = 1; el.style.transform = 'none'; });
  }

  /* ================= PRODUCT PAGE ================= */
  var pdp = $('main.page-product');
  if (pdp) {
    // Gallery
    var slides = $$('.gal__slide'), thumbs = $$('.gal__thumb'), gi = 0;
    var showSlide = function (i) { gi = i; slides.forEach(function (s, j) { s.classList.toggle('is-on', j === i); }); thumbs.forEach(function (t, j) { t.classList.toggle('is-on', j === i); }); };
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showSlide(+t.getAttribute('data-i')); }); });
    var gal = $('.gal');
    if (gal) gal.addEventListener('click', function (e) { if (e.target.closest('[data-facts]')) return; showSlide((gi + 1) % slides.length); });
    var gprev = $('.gal__prev'), gnext = $('.gal__next');
    if (gprev) gprev.addEventListener('click', function (e) { e.stopPropagation(); showSlide((gi - 1 + slides.length) % slides.length); });
    if (gnext) gnext.addEventListener('click', function (e) { e.stopPropagation(); showSlide((gi + 1) % slides.length); });
    /* Nutrition Facts slide: scale the fixed-size label card to the tile, open a readable lightbox on tap */
    var facts = $('[data-facts]');
    function fitFacts() {
      if (!facts || !gal) return;
      if (window.matchMedia('(max-width: 900px)').matches) { facts.style.removeProperty('--fs'); return; }
      var r = gal.getBoundingClientRect(), s = Math.min((r.width - 20 - 28) / 440, (r.height - 20 - 28) / 755); /* ROUND 14: card fills the slide, content scales inside */
      facts.style.setProperty('--fs', String(Math.min(1, s)));
    }
    if (facts) {
      fitFacts(); window.addEventListener('resize', fitFacts);
      if (window.ResizeObserver) new ResizeObserver(fitFacts).observe(gal);
      var lb = document.createElement('div'); lb.className = 'facts-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Nutrition Facts');
      var inner = document.createElement('div'); inner.className = 'facts-lb__inner'; inner.style.setProperty('--tint', getComputedStyle(gal).getPropertyValue('--tint'));
      var close = document.createElement('button'); close.type = 'button'; close.className = 'facts-lb__close'; close.setAttribute('aria-label', 'Close'); close.textContent = '×';
      var clone = facts.cloneNode(true); clone.removeAttribute('data-facts'); clone.style.removeProperty('--fs');
      inner.appendChild(close); inner.appendChild(clone); lb.appendChild(inner); document.body.appendChild(lb);
      var openLb = function () { lb.classList.add('is-open'); document.body.classList.add('facts-lb-open'); close.focus(); };
      var closeLb = function () { lb.classList.remove('is-open'); document.body.classList.remove('facts-lb-open'); };
      facts.addEventListener('click', function (e) { e.stopPropagation(); openLb(); });
      close.addEventListener('click', closeLb);
      lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb.classList.contains('is-open')) closeLb(); });
    }
    if (hasGsap && !reduce) {
      var bottle = $('.gal__bottle');
      if (bottle) {
        gsap.from(bottle, { y: 60, opacity: 0, duration: 1.2, ease: 'power3.out' });
        if (!isMobile) gsap.to(bottle, { y: -14, duration: 3, yoyo: true, repeat: -1, ease: 'sine.inOut', delay: 1.2 });
        if (!isMobile) gal.addEventListener('mousemove', function (e) {
          var r = gal.getBoundingClientRect();
          gsap.to(bottle, { rotationY: ((e.clientX - r.left) / r.width - 0.5) * 18, rotationX: -((e.clientY - r.top) / r.height - 0.5) * 10, transformPerspective: 900, duration: 0.8 });
        });
      }
      gsap.fromTo('.pdp__info > *', { opacity: 0, y: 20 }, { opacity: 1, y: 0, stagger: 0.06, duration: 0.8, ease: 'power3.out', delay: 0.1 });
    }

    // Buy box (Cadence-style)
    var form = $('#buyForm');
    if (form) {
      var priceEl = form.querySelector('[name=id]'); var price = parseFloat(form.getAttribute('data-price') || (priceEl && (priceEl.selectedOptions ? priceEl.selectedOptions[0].getAttribute('data-price') : priceEl.getAttribute('data-price'))) || 0), pct = parseFloat(form.getAttribute('data-subpct')) || 0;
      var handle = form.getAttribute('data-handle');
      var qtyIn = $('#qty'), addBtn = $('#addBtn'), addPrice = $('#addPrice'), sticky = $('#stickyBuy'), stickyPrice = $('#stickyPrice');
      var opts = $$('.buy__opt', form);
      var state = function () {
        var plan = (form.querySelector('input[name=plan]:checked') || {}).value || 'once';
        var freq = (form.querySelector('input[name=freq]:checked') || {}).value || '4 weeks';
        var q = Math.max(1, parseInt(qtyIn && qtyIn.value, 10) || 1);
        var unit = plan === 'sub' ? price * (1 - pct / 100) : price;
        return { plan: plan, freq: freq, q: q, unit: unit, total: unit * q };
      };
      var render = function () {
        var s = state();
        opts.forEach(function (o) { o.classList.toggle('is-on', o.querySelector('input[name=plan]').checked); });
        var label = s.plan === 'sub' ? 'Subscribe · ' + money(s.total) : 'Add to cart · ' + money(s.total);
        if (addPrice) addPrice.textContent = money(s.total);
        if (addBtn && !addPrice) addBtn.querySelector('span').textContent = label;
        if (stickyPrice) stickyPrice.textContent = money(s.unit) + (s.plan === 'sub' ? ' · every ' + s.freq : ' · 12-pack');
      };
      form.addEventListener('change', render);
      $$('[data-q]', form).forEach(function (b) { b.addEventListener('click', function () { qtyIn.value = Math.max(1, (parseInt(qtyIn.value, 10) || 1) + parseInt(b.getAttribute('data-q'), 10)); render(); }); });
      var doAdd = function (e) {
        if (e) e.preventDefault(); var s = state();
        var idEl = form.querySelector('[name=id]'); if (!idEl) return;
        var item = { id: parseInt(idEl.value, 10), quantity: s.q };
        if (s.plan === 'sub') { var sp = form.querySelector('input[name=freq]:checked') || form.querySelector('input[name=selling_plan]'); if (sp && sp.value) item.selling_plan = parseInt(sp.value, 10); }
        cartAddItems([item], addBtn);
      };
      form.addEventListener('submit', doAdd);
      if (addBtn && addBtn.type !== 'submit') addBtn.addEventListener('click', doAdd);
      var stickyAdd = $('#stickyAdd'); if (stickyAdd) stickyAdd.addEventListener('click', doAdd);
      render();
      if (sticky) {
        var check = function () { var r = form.getBoundingClientRect(); var on = r.bottom < 0 && window.scrollY < document.documentElement.scrollHeight - window.innerHeight - 600; sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', String(!on)); };
        window.addEventListener('scroll', check, { passive: true }); if (lenis) lenis.on('scroll', check);
      }
    }
    $$('.js-write-review').forEach(function (a) { a.addEventListener('click', function (e) { if (a.closest('[data-reviews]')) return; e.preventDefault(); toast('Reviews open once a reviews app (e.g. Judge.me) is installed in Shopify.'); }); });
    if (hasGsap && !reduce) {
      gsap.fromTo('.stats__row div', { opacity: 0, y: 20 }, { opacity: 1, y: 0, stagger: 0.08, duration: 0.8, scrollTrigger: { trigger: '.stats', start: 'top 80%' } });
      gsap.fromTo('.ing', { opacity: 0, y: 30 }, { opacity: 1, y: 0, stagger: 0.08, duration: 0.9, scrollTrigger: { trigger: '.inside__grid', start: 'top 80%' } });
      gsap.fromTo('.xsell', { opacity: 0, y: 30 }, { opacity: 1, y: 0, stagger: 0.08, duration: 0.9, scrollTrigger: { trigger: '.xsells__row', start: 'top 85%' } });
      gsap.fromTo('.faq__list details', { opacity: 0, y: 16 }, { opacity: 1, y: 0, stagger: 0.06, duration: 0.7, scrollTrigger: { trigger: '.faq', start: 'top 80%' } });
    }
  }

  /* ================= COLLECTION FILTERS ================= */
  $$('.coll__filters .chip').forEach(function (c) {
    c.addEventListener('click', function () {
      var f = c.getAttribute('data-filter');
      $$('.coll__filters .chip').forEach(function (x) { x.classList.toggle('is-on', x === c); });
      $$('#collGrid .product').forEach(function (p) {
        var isNew = p.classList.contains('product--new');
        p.classList.toggle('is-hidden', !(f === 'all' || (f === 'new' && isNew) || (f === 'original' && !isNew)));
      });
    });
  });
  if (hasGsap && !reduce && $('#collGrid')) gsap.fromTo('#collGrid .product', { opacity: 0, y: 40 }, { opacity: 1, y: 0, stagger: 0.07, duration: 0.9, ease: 'power3.out', delay: 0.2 });

  /* ================= STORE LOCATOR ================= */
  /* ROUND 16 · store locator: filter chips + live search over the real store list */
  var locForm = $('#locForm'), locList = $('#locList');
  if (locForm && locList) {
    var stores = $$('.store', locList), filters = $$('.loc-filter'), count = $('#locCount'), empty = $('#locEmpty'), input = $('#locQuery'), chain = 'all';
    var labels = { all: 'locations in Minnesota', lunds: 'Lunds & Byerlys stores', kowalskis: "Kowalski's Markets", freshthyme: 'Fresh Thyme Markets', hyvee: 'Hy-Vee stores', community: 'gyms and courts' };
    function apply() {
      var q = (input.value || '').trim().toLowerCase().replace(/\s+/g, ' ').replace(/,?\s*(mn|minnesota)$/, '').replace(/^(\d{5})(-\d{4})?$/, '$1');
      var zip = /^\d{3,5}$/.test(q) ? q : '', n = 0;
      stores.forEach(function (s) {
        var ok = chain === 'all' || s.getAttribute('data-chain') === chain;
        if (ok && q) {
          if (zip) { var z = s.getAttribute('data-zip'); ok = z.indexOf(zip) === 0 || (zip.length === 5 && z.slice(0, 3) === zip.slice(0, 3)); }
          else ok = s.getAttribute('data-text').indexOf(q) > -1;
        }
        s.hidden = !ok; if (ok) n++;
      });
      if (count) count.textContent = n ? (q ? 'Showing ' + n + ' of ' + stores.length + ' locations' + (zip ? ' near ' + zip : ' for “' + q + '”') + '.' : 'Showing all ' + n + ' ' + labels[chain] + '.') : '';
      if (empty) empty.hidden = n > 0;
    }
    filters.forEach(function (f) { f.addEventListener('click', function () { chain = f.getAttribute('data-filter'); filters.forEach(function (x) { x.classList.toggle('is-on', x === f); }); apply(); }); });
    input.addEventListener('input', apply);
    locForm.addEventListener('submit', function (e) { e.preventDefault(); apply(); var first = stores.filter(function (s) { return !s.hidden; })[0]; if (first) first.scrollIntoView({ block: 'center', behavior: 'smooth' }); });
    apply();
  }
  var reqForm = $('#reqForm');
  if (reqForm && !reqForm.hasAttribute('data-native')) reqForm.addEventListener('submit', function (e) { e.preventDefault(); $('#reqMsg').textContent = 'Thanks. We will reach out to ' + ($('#reqStore').value || 'that store') + '.'; reqForm.reset(); });

  /* ================= NEWSLETTER / POPUP ================= */
  var nl = $('#newsletter');
  if (nl) nl.addEventListener('submit', function (e) {
    var m = $('#newsletterMsg'), inp = $('#nlEmail'); if (!inp) return;
    var v = (inp.value || '').trim().toLowerCase().replace(/^mailto:/, '').replace(/\s+/g, '');
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(v)) { e.preventDefault(); if (m) m.textContent = 'That email looks incomplete. Try something like name@domain.com.'; inp.focus(); return; }
    inp.value = v; if (m) m.textContent = 'One moment…';
  });

  var popup = $('#popup');
  if (popup) {
    var shown = false;
    var openPopup = function () { if (shown) return; shown = true; popup.hidden = false; requestAnimationFrame(function () { popup.classList.add('is-on'); }); };
    var closePopup = function () { popup.classList.remove('is-on'); setTimeout(function () { popup.hidden = true; }, 400); };
    var seen = false; try { seen = !!sessionStorage.getItem('xh_popup'); } catch (err) { seen = false; }
    if (popup.getAttribute('data-posted') === 'true') seen = true;
    if (!seen) setTimeout(function () { try { sessionStorage.setItem('xh_popup', '1'); } catch (err) {} openPopup(); }, parseInt(popup.getAttribute('data-delay'), 10) || 5000);
    var pc = $('#popupClose'); if (pc) pc.addEventListener('click', closePopup);
    var ps = $('#popupSkip'); if (ps) ps.addEventListener('click', closePopup);
    popup.addEventListener('click', function (e) { if (e.target === popup) closePopup(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closePopup(); cartClose(); } });
    var pf = $('#popupForm') || $('#popupCustomerForm');
    if (pf) pf.addEventListener('submit', function (e) {
      var inp = pf.querySelector('input[type=email]'); var v = inp ? (inp.value || '').trim() : '';
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(v)) { e.preventDefault(); if (inp) inp.focus(); return; }
      try { sessionStorage.setItem('xh_popup', '1'); } catch (err) {}
    });
    if (popup.getAttribute('data-posted') === 'true') { shown = true; popup.hidden = false; requestAnimationFrame(function () { popup.classList.add('is-on'); }); setTimeout(closePopup, 4500); }
  }

  /* ================= CART (in-memory preview; Shopify cart on port) ================= */
  var drawer = $('#cartDrawer');
  var cartOpen = function () { if (!drawer) return; drawer.classList.add('is-on'); drawer.setAttribute('aria-hidden', 'false'); };
  var cartClose = function () { if (!drawer) return; drawer.classList.remove('is-on'); drawer.setAttribute('aria-hidden', 'true'); };
  var freeShip = parseFloat(XH.freeShipThreshold) || 0;
  function flashAdded(btn) {
    if (!btn) return; var sp = btn.querySelector('span') || btn; if (btn._t) return;
    var was = sp.innerHTML; btn.classList.add('is-added'); sp.textContent = 'Added';
    var c = $('#cartCount'); if (c) { c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); }
    btn._t = setTimeout(function () { sp.innerHTML = was; btn.classList.remove('is-added'); btn._t = null; }, 1400);
  }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function cartFetch(path, opts) {
    return fetch(path, Object.assign({ credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } }, opts || {})).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Cart error'); return d; });
    });
  }
  function cartAddItems(items, btn) {
    if (btn) btn.classList.add('is-busy');
    return cartFetch('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: items }) }).then(function (d) {
      flashAdded(btn);
      var hello = $('#cartHello'); var first = d.items ? d.items[0] : d; if (hello && first) hello.textContent = 'Good call. ' + first.product_title + ' is in your cart.';
      return cartRefresh().then(cartOpen);
    }).catch(function (err) { toast(err.message || 'Could not add that right now.'); }).then(function () { if (btn) btn.classList.remove('is-busy'); });
  }
  function cartChange(key, q) {
    return cartFetch('/cart/change.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: q }) }).then(cartRender).catch(function (err) { toast(err.message || 'Could not update the cart.'); });
  }
  function cartRefresh() { return cartFetch('/cart.js').then(cartRender).catch(function () {}); }
  function cartRender(cart) {
    if (!drawer || !cart) return;
    var lines = $('#cartLines'), empty = $('#cartEmpty'), count = $('#cartCount'), sub = cart.items_subtotal_price / 100;
    lines.innerHTML = cart.items.map(function (l) {
      var img = l.image ? l.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x$1$2') : '';
      var meta = (l.variant_title && l.variant_title !== 'Default Title' ? l.variant_title : '') + (l.selling_plan_allocation ? (l.variant_title && l.variant_title !== 'Default Title' ? ' · ' : '') + l.selling_plan_allocation.selling_plan.name : '');
      return '<li class="cart__line" data-key="' + esc(l.key) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="60" height="60" loading="lazy">' : '<span class="cart__noimg"></span>') +
        '<div><b><a href="' + esc(l.url) + '">' + esc(l.product_title) + '</a></b>' + (meta ? '<small>' + esc(meta) + '</small>' : '') +
        '<div class="cart__qty"><button type="button" data-ci="' + esc(l.key) + '" data-d="-1" aria-label="Fewer">−</button><span>' + l.quantity + '</span><button type="button" data-ci="' + esc(l.key) + '" data-d="1" aria-label="More">+</button></div></div>' +
        '<div class="cart__right"><b>' + money(l.final_line_price / 100) + '</b><button type="button" class="cart__rm" data-rm="' + esc(l.key) + '">Remove</button></div></li>';
    }).join('');
    if (empty) empty.style.display = cart.items.length ? 'none' : '';
    var st = $('#cartSubtotal'); if (st) st.textContent = money(sub);
    if (count) { count.textContent = cart.item_count; count.classList.toggle('is-on', cart.item_count > 0); }
    var ship = $('#cartShip'), bar = $('#cartShipBar'), msgEl = $('#cartShipMsg');
    if (ship && freeShip > 0) {
      var left = Math.max(0, freeShip - sub);
      if (bar) bar.style.setProperty('--p', Math.min(1, sub / freeShip));
      if (msgEl) msgEl.textContent = left > 0 ? (ship.getAttribute('data-msg-left') || '{{amount}} away from free shipping.').replace('{{amount}}', money(left)) : (ship.getAttribute('data-msg-done') || 'You have free shipping.');
    } else if (ship) { ship.style.display = 'none'; }
    $$('[data-ci]', lines).forEach(function (b) { b.addEventListener('click', function () { var li = b.closest('.cart__line'); var q = parseInt(li.querySelector('.cart__qty span').textContent, 10) + parseInt(b.getAttribute('data-d'), 10); cartChange(b.getAttribute('data-ci'), Math.max(0, q)); }); });
    $$('[data-rm]', lines).forEach(function (b) { b.addEventListener('click', function () { cartChange(b.getAttribute('data-rm'), 0); }); });
  }
  if (drawer) {
    var cb = $('#cartBtn'); if (cb) cb.addEventListener('click', function (e) { e.preventDefault(); cartRefresh(); cartOpen(); });
    var cc = $('#cartClose'); if (cc) cc.addEventListener('click', cartClose);
    var cs = $('#cartScrim'); if (cs) cs.addEventListener('click', cartClose);
    cartRefresh();
  }
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f.matches || !f.matches('form[data-ajax-add]') || f.id === 'buyForm') return;
    e.preventDefault();
    var id = f.querySelector('[name=id]'), q = f.querySelector('[name=quantity]'), sp = f.querySelector('[name=selling_plan]:checked');
    if (!id) return; var item = { id: parseInt(id.value, 10), quantity: Math.max(1, parseInt(q && q.value, 10) || 1) }; if (sp && sp.value) item.selling_plan = parseInt(sp.value, 10);
    cartAddItems([item], f.querySelector('button[type=submit]'));
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add]'); if (!b || b.closest('#buyForm') || b.closest('form[data-ajax-add]')) return;
    var vid = parseInt(b.getAttribute('data-variant') || b.getAttribute('data-add'), 10); if (!vid) return;
    e.preventDefault(); cartAddItems([{ id: vid, quantity: 1 }], b);
  });

  /* ---------- toast ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.setAttribute('role', 'status'); toastEl.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%) translateY(20px);background:#0A0B0D;color:#fff;padding:14px 20px;border-radius:14px;font-size:14px;max-width:min(560px,90vw);z-index:200;opacity:0;transition:all .4s cubic-bezier(.22,1,.36,1)'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.style.opacity = 1; toastEl.style.transform = 'translateX(-50%)';
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.style.opacity = 0; toastEl.style.transform = 'translateX(-50%) translateY(20px)'; }, parseInt(popup.getAttribute('data-delay'), 10) || 5000);
  }

  window.addEventListener('load', function () { if (hasGsap) ScrollTrigger.refresh(); });
})();

/* Per-flavor reviews (static preview): stored in this browser until a reviews app is connected in Shopify. */
(function () {
  var sec = document.querySelector('[data-reviews]'); if (!sec) return;
  var key = 'xh_reviews_' + sec.getAttribute('data-reviews'), list = sec.querySelector('[data-review-list]'), empty = sec.querySelector('[data-review-empty]'),
      form = sec.querySelector('[data-review-form]'), count = sec.querySelector('[data-review-count]');
  function load() { try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { return []; } }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function render() {
    var rs = load();
    list.querySelectorAll('.rcard--user').forEach(function (n) { n.remove(); });
    if (empty) empty.hidden = rs.length > 0;
    rs = rs.filter(function (r) { return r && typeof r === 'object'; }).map(function (r) { var n = parseInt(r.rating, 10); r.rating = isNaN(n) ? 5 : Math.min(5, Math.max(1, n)); r.text = String(r.text || '').slice(0, 400); r.name = String(r.name || '').slice(0, 40); r.date = String(r.date || '').slice(0, 40); return r; });
    rs.slice().reverse().forEach(function (r) {
      var a = document.createElement('article'); a.className = 'rcard rcard--user';
      a.innerHTML = '<p class="stars" aria-label="' + r.rating + ' out of 5">' + '★★★★★'.slice(0, r.rating) + '<span class="stars--off">' + '★★★★★'.slice(r.rating) + '</span></p><p class="rcard__text">"' + esc(r.text) + '"</p><p class="rcard__who">' + esc(r.name) + ' <span>' + esc(r.date) + '</span></p>';
      list.appendChild(a);
    });
    if (count) count.textContent = rs.length ? rs.length + ' review' + (rs.length > 1 ? 's' : '') + ' · ' + (rs.reduce(function (a, r) { return a + r.rating; }, 0) / rs.length).toFixed(1) + ' / 5' : count.getAttribute('data-empty');
  }
  sec.addEventListener('click', function (e) {
    var t = e.target.closest('.js-write-review'); if (!t || !form) return;
    e.preventDefault(); form.hidden = false; form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var i = form.querySelector('input[name=name]'); if (i) setTimeout(function () { i.focus(); }, 450);
  });
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    var fd = new FormData(form), name = String(fd.get('name') || '').trim(), text = String(fd.get('text') || '').trim(), rating = Math.max(1, Math.min(5, +(fd.get('rating') || 5)));
    var msg = form.querySelector('.form__msg');
    if (!name || !text) { if (msg) msg.textContent = 'Add a name and a few words first.'; return; }
    var rs = load(); rs.push({ name: name, text: text, rating: rating, date: new Date().toLocaleDateString('en-US', { month: 'short', year: 'numeric' }) });
    try { localStorage.setItem(key, JSON.stringify(rs)); } catch (err) {}
    form.reset(); if (msg) msg.textContent = 'Thanks. Your review is up.'; render();
  });
  render();
})();
